/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthedImport } from './routes/_authed'
import { Route as ClosedIndexImport } from './routes/closed/index'
import { Route as AuthedIndexImport } from './routes/_authed/index'
import { Route as SStoreSlugImport } from './routes/s/$storeSlug'
import { Route as AuthedAboutCampaignImport } from './routes/_authed/about-campaign'
import { Route as AuthedAboutAdditionalCampaignImport } from './routes/_authed/about-additional-campaign'
import { Route as AuthedTransferIndexImport } from './routes/_authed/transfer/index'
import { Route as AuthedTransactionsIndexImport } from './routes/_authed/transactions/index'
import { Route as AuthedSubscribeIndexImport } from './routes/_authed/subscribe/index'
import { Route as AuthedStoresIndexImport } from './routes/_authed/stores/index'
import { Route as AuthedSettingsIndexImport } from './routes/_authed/settings/index'
import { Route as AuthedReceiveIndexImport } from './routes/_authed/receive/index'
import { Route as AuthedKyotoRepresentativeCampaignIndexImport } from './routes/_authed/kyoto-representative-campaign/index'
import { Route as AuthedInvitationIndexImport } from './routes/_authed/invitation/index'
import { Route as AuthedChargeIndexImport } from './routes/_authed/charge/index'
import { Route as AuthedBalancesIndexImport } from './routes/_authed/balances/index'
import { Route as AuthedTransactionsGroupIdImport } from './routes/_authed/transactions/$groupId'
import { Route as AuthedSdDistributionCodeImport } from './routes/_authed/sd/$distributionCode'
import { Route as AuthedResidenceCardApplyImport } from './routes/_authed/residence-card/apply'
import { Route as AuthedPayStoreSlugImport } from './routes/_authed/pay/$storeSlug'
import { Route as AuthedLotteryResultImport } from './routes/_authed/lottery/result'
import { Route as AuthedLotteryProcessingImport } from './routes/_authed/lottery/processing'
import { Route as AuthedLotteryApplyImport } from './routes/_authed/lottery/apply'
import { Route as AuthedKyotoRepresentativeCampaignProcessingImport } from './routes/_authed/kyoto-representative-campaign/processing'
import { Route as AuthedInvitationDetailImport } from './routes/_authed/invitation/detail'
import { Route as AuthedInvitationApplyImport } from './routes/_authed/invitation/apply'
import { Route as AuthedIInvitationCodeImport } from './routes/_authed/i/$invitationCode'
import { Route as AuthedHkpCodeImport } from './routes/_authed/hkp/$code'
import { Route as AuthedDDistributionCodeImport } from './routes/_authed/d/$distributionCode'
import { Route as AuthedChargeMypaymentImport } from './routes/_authed/charge/mypayment'
import { Route as AuthedChargeCreditImport } from './routes/_authed/charge/credit'
import { Route as AuthedChargeCompleteImport } from './routes/_authed/charge/complete'
import { Route as AuthedTransferAcceptTransferCodeImport } from './routes/_authed/transfer/accept.$transferCode'
import { Route as AuthedLotteryGrantResultImport } from './routes/_authed/lottery/grant.result'
import { Route as AuthedLotteryGrantProcessingImport } from './routes/_authed/lottery/grant.processing'
import { Route as AuthedLotteryBousaiMockImport } from './routes/_authed/lottery/bousai.mock'
import { Route as AuthedLotteryBousaiCallbackImport } from './routes/_authed/lottery/bousai.callback'
import { Route as AuthedChargeCreditCardManageImport } from './routes/_authed/charge/credit-card.manage'
import { Route as AuthedChargeCreditCardAddImport } from './routes/_authed/charge/credit-card.add'
import { Route as AuthedTransferQrFundSourceIdAmountImport } from './routes/_authed/transfer/qr.$fundSourceId.$amount'
import { Route as AuthedTransferInputFundSourceIdAmountImport } from './routes/_authed/transfer/input.$fundSourceId.$amount'
import { Route as AuthedChargeCreditCardManageGmoCardIdImport } from './routes/_authed/charge/credit-card.manage_.$gmoCardId'

// Create/Update Routes

const AuthedRoute = AuthedImport.update({
  id: '/_authed',
  getParentRoute: () => rootRoute,
} as any)

const ClosedIndexRoute = ClosedIndexImport.update({
  id: '/closed/',
  path: '/closed/',
  getParentRoute: () => rootRoute,
} as any)

const AuthedIndexRoute = AuthedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)

const SStoreSlugRoute = SStoreSlugImport.update({
  id: '/s/$storeSlug',
  path: '/s/$storeSlug',
  getParentRoute: () => rootRoute,
} as any)

const AuthedAboutCampaignRoute = AuthedAboutCampaignImport.update({
  id: '/about-campaign',
  path: '/about-campaign',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedAboutAdditionalCampaignRoute =
  AuthedAboutAdditionalCampaignImport.update({
    id: '/about-additional-campaign',
    path: '/about-additional-campaign',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedTransferIndexRoute = AuthedTransferIndexImport.update({
  id: '/transfer/',
  path: '/transfer/',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedTransactionsIndexRoute = AuthedTransactionsIndexImport.update({
  id: '/transactions/',
  path: '/transactions/',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedSubscribeIndexRoute = AuthedSubscribeIndexImport.update({
  id: '/subscribe/',
  path: '/subscribe/',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedStoresIndexRoute = AuthedStoresIndexImport.update({
  id: '/stores/',
  path: '/stores/',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedSettingsIndexRoute = AuthedSettingsIndexImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedReceiveIndexRoute = AuthedReceiveIndexImport.update({
  id: '/receive/',
  path: '/receive/',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedKyotoRepresentativeCampaignIndexRoute =
  AuthedKyotoRepresentativeCampaignIndexImport.update({
    id: '/kyoto-representative-campaign/',
    path: '/kyoto-representative-campaign/',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedInvitationIndexRoute = AuthedInvitationIndexImport.update({
  id: '/invitation/',
  path: '/invitation/',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedChargeIndexRoute = AuthedChargeIndexImport.update({
  id: '/charge/',
  path: '/charge/',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedBalancesIndexRoute = AuthedBalancesIndexImport.update({
  id: '/balances/',
  path: '/balances/',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedTransactionsGroupIdRoute = AuthedTransactionsGroupIdImport.update({
  id: '/transactions/$groupId',
  path: '/transactions/$groupId',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedSdDistributionCodeRoute = AuthedSdDistributionCodeImport.update({
  id: '/sd/$distributionCode',
  path: '/sd/$distributionCode',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedResidenceCardApplyRoute = AuthedResidenceCardApplyImport.update({
  id: '/residence-card/apply',
  path: '/residence-card/apply',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedPayStoreSlugRoute = AuthedPayStoreSlugImport.update({
  id: '/pay/$storeSlug',
  path: '/pay/$storeSlug',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedLotteryResultRoute = AuthedLotteryResultImport.update({
  id: '/lottery/result',
  path: '/lottery/result',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedLotteryProcessingRoute = AuthedLotteryProcessingImport.update({
  id: '/lottery/processing',
  path: '/lottery/processing',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedLotteryApplyRoute = AuthedLotteryApplyImport.update({
  id: '/lottery/apply',
  path: '/lottery/apply',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedKyotoRepresentativeCampaignProcessingRoute =
  AuthedKyotoRepresentativeCampaignProcessingImport.update({
    id: '/kyoto-representative-campaign/processing',
    path: '/kyoto-representative-campaign/processing',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedInvitationDetailRoute = AuthedInvitationDetailImport.update({
  id: '/invitation/detail',
  path: '/invitation/detail',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedInvitationApplyRoute = AuthedInvitationApplyImport.update({
  id: '/invitation/apply',
  path: '/invitation/apply',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedIInvitationCodeRoute = AuthedIInvitationCodeImport.update({
  id: '/i/$invitationCode',
  path: '/i/$invitationCode',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedHkpCodeRoute = AuthedHkpCodeImport.update({
  id: '/hkp/$code',
  path: '/hkp/$code',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedDDistributionCodeRoute = AuthedDDistributionCodeImport.update({
  id: '/d/$distributionCode',
  path: '/d/$distributionCode',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedChargeMypaymentRoute = AuthedChargeMypaymentImport.update({
  id: '/charge/mypayment',
  path: '/charge/mypayment',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedChargeCreditRoute = AuthedChargeCreditImport.update({
  id: '/charge/credit',
  path: '/charge/credit',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedChargeCompleteRoute = AuthedChargeCompleteImport.update({
  id: '/charge/complete',
  path: '/charge/complete',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedTransferAcceptTransferCodeRoute =
  AuthedTransferAcceptTransferCodeImport.update({
    id: '/transfer/accept/$transferCode',
    path: '/transfer/accept/$transferCode',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedLotteryGrantResultRoute = AuthedLotteryGrantResultImport.update({
  id: '/lottery/grant/result',
  path: '/lottery/grant/result',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedLotteryGrantProcessingRoute =
  AuthedLotteryGrantProcessingImport.update({
    id: '/lottery/grant/processing',
    path: '/lottery/grant/processing',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedLotteryBousaiMockRoute = AuthedLotteryBousaiMockImport.update({
  id: '/lottery/bousai/mock',
  path: '/lottery/bousai/mock',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedLotteryBousaiCallbackRoute =
  AuthedLotteryBousaiCallbackImport.update({
    id: '/lottery/bousai/callback',
    path: '/lottery/bousai/callback',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedChargeCreditCardManageRoute =
  AuthedChargeCreditCardManageImport.update({
    id: '/charge/credit-card/manage',
    path: '/charge/credit-card/manage',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedChargeCreditCardAddRoute = AuthedChargeCreditCardAddImport.update({
  id: '/charge/credit-card/add',
  path: '/charge/credit-card/add',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedTransferQrFundSourceIdAmountRoute =
  AuthedTransferQrFundSourceIdAmountImport.update({
    id: '/transfer/qr/$fundSourceId/$amount',
    path: '/transfer/qr/$fundSourceId/$amount',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedTransferInputFundSourceIdAmountRoute =
  AuthedTransferInputFundSourceIdAmountImport.update({
    id: '/transfer/input/$fundSourceId/$amount',
    path: '/transfer/input/$fundSourceId/$amount',
    getParentRoute: () => AuthedRoute,
  } as any)

const AuthedChargeCreditCardManageGmoCardIdRoute =
  AuthedChargeCreditCardManageGmoCardIdImport.update({
    id: '/charge/credit-card/manage_/$gmoCardId',
    path: '/charge/credit-card/manage/$gmoCardId',
    getParentRoute: () => AuthedRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedImport
      parentRoute: typeof rootRoute
    }
    '/_authed/about-additional-campaign': {
      id: '/_authed/about-additional-campaign'
      path: '/about-additional-campaign'
      fullPath: '/about-additional-campaign'
      preLoaderRoute: typeof AuthedAboutAdditionalCampaignImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/about-campaign': {
      id: '/_authed/about-campaign'
      path: '/about-campaign'
      fullPath: '/about-campaign'
      preLoaderRoute: typeof AuthedAboutCampaignImport
      parentRoute: typeof AuthedImport
    }
    '/s/$storeSlug': {
      id: '/s/$storeSlug'
      path: '/s/$storeSlug'
      fullPath: '/s/$storeSlug'
      preLoaderRoute: typeof SStoreSlugImport
      parentRoute: typeof rootRoute
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexImport
      parentRoute: typeof AuthedImport
    }
    '/closed/': {
      id: '/closed/'
      path: '/closed'
      fullPath: '/closed'
      preLoaderRoute: typeof ClosedIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authed/charge/complete': {
      id: '/_authed/charge/complete'
      path: '/charge/complete'
      fullPath: '/charge/complete'
      preLoaderRoute: typeof AuthedChargeCompleteImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/charge/credit': {
      id: '/_authed/charge/credit'
      path: '/charge/credit'
      fullPath: '/charge/credit'
      preLoaderRoute: typeof AuthedChargeCreditImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/charge/mypayment': {
      id: '/_authed/charge/mypayment'
      path: '/charge/mypayment'
      fullPath: '/charge/mypayment'
      preLoaderRoute: typeof AuthedChargeMypaymentImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/d/$distributionCode': {
      id: '/_authed/d/$distributionCode'
      path: '/d/$distributionCode'
      fullPath: '/d/$distributionCode'
      preLoaderRoute: typeof AuthedDDistributionCodeImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/hkp/$code': {
      id: '/_authed/hkp/$code'
      path: '/hkp/$code'
      fullPath: '/hkp/$code'
      preLoaderRoute: typeof AuthedHkpCodeImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/i/$invitationCode': {
      id: '/_authed/i/$invitationCode'
      path: '/i/$invitationCode'
      fullPath: '/i/$invitationCode'
      preLoaderRoute: typeof AuthedIInvitationCodeImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/invitation/apply': {
      id: '/_authed/invitation/apply'
      path: '/invitation/apply'
      fullPath: '/invitation/apply'
      preLoaderRoute: typeof AuthedInvitationApplyImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/invitation/detail': {
      id: '/_authed/invitation/detail'
      path: '/invitation/detail'
      fullPath: '/invitation/detail'
      preLoaderRoute: typeof AuthedInvitationDetailImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/kyoto-representative-campaign/processing': {
      id: '/_authed/kyoto-representative-campaign/processing'
      path: '/kyoto-representative-campaign/processing'
      fullPath: '/kyoto-representative-campaign/processing'
      preLoaderRoute: typeof AuthedKyotoRepresentativeCampaignProcessingImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/lottery/apply': {
      id: '/_authed/lottery/apply'
      path: '/lottery/apply'
      fullPath: '/lottery/apply'
      preLoaderRoute: typeof AuthedLotteryApplyImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/lottery/processing': {
      id: '/_authed/lottery/processing'
      path: '/lottery/processing'
      fullPath: '/lottery/processing'
      preLoaderRoute: typeof AuthedLotteryProcessingImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/lottery/result': {
      id: '/_authed/lottery/result'
      path: '/lottery/result'
      fullPath: '/lottery/result'
      preLoaderRoute: typeof AuthedLotteryResultImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/pay/$storeSlug': {
      id: '/_authed/pay/$storeSlug'
      path: '/pay/$storeSlug'
      fullPath: '/pay/$storeSlug'
      preLoaderRoute: typeof AuthedPayStoreSlugImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/residence-card/apply': {
      id: '/_authed/residence-card/apply'
      path: '/residence-card/apply'
      fullPath: '/residence-card/apply'
      preLoaderRoute: typeof AuthedResidenceCardApplyImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/sd/$distributionCode': {
      id: '/_authed/sd/$distributionCode'
      path: '/sd/$distributionCode'
      fullPath: '/sd/$distributionCode'
      preLoaderRoute: typeof AuthedSdDistributionCodeImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/transactions/$groupId': {
      id: '/_authed/transactions/$groupId'
      path: '/transactions/$groupId'
      fullPath: '/transactions/$groupId'
      preLoaderRoute: typeof AuthedTransactionsGroupIdImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/balances/': {
      id: '/_authed/balances/'
      path: '/balances'
      fullPath: '/balances'
      preLoaderRoute: typeof AuthedBalancesIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/charge/': {
      id: '/_authed/charge/'
      path: '/charge'
      fullPath: '/charge'
      preLoaderRoute: typeof AuthedChargeIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/invitation/': {
      id: '/_authed/invitation/'
      path: '/invitation'
      fullPath: '/invitation'
      preLoaderRoute: typeof AuthedInvitationIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/kyoto-representative-campaign/': {
      id: '/_authed/kyoto-representative-campaign/'
      path: '/kyoto-representative-campaign'
      fullPath: '/kyoto-representative-campaign'
      preLoaderRoute: typeof AuthedKyotoRepresentativeCampaignIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/receive/': {
      id: '/_authed/receive/'
      path: '/receive'
      fullPath: '/receive'
      preLoaderRoute: typeof AuthedReceiveIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/settings/': {
      id: '/_authed/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/stores/': {
      id: '/_authed/stores/'
      path: '/stores'
      fullPath: '/stores'
      preLoaderRoute: typeof AuthedStoresIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/subscribe/': {
      id: '/_authed/subscribe/'
      path: '/subscribe'
      fullPath: '/subscribe'
      preLoaderRoute: typeof AuthedSubscribeIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/transactions/': {
      id: '/_authed/transactions/'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof AuthedTransactionsIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/transfer/': {
      id: '/_authed/transfer/'
      path: '/transfer'
      fullPath: '/transfer'
      preLoaderRoute: typeof AuthedTransferIndexImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/charge/credit-card/add': {
      id: '/_authed/charge/credit-card/add'
      path: '/charge/credit-card/add'
      fullPath: '/charge/credit-card/add'
      preLoaderRoute: typeof AuthedChargeCreditCardAddImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/charge/credit-card/manage': {
      id: '/_authed/charge/credit-card/manage'
      path: '/charge/credit-card/manage'
      fullPath: '/charge/credit-card/manage'
      preLoaderRoute: typeof AuthedChargeCreditCardManageImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/lottery/bousai/callback': {
      id: '/_authed/lottery/bousai/callback'
      path: '/lottery/bousai/callback'
      fullPath: '/lottery/bousai/callback'
      preLoaderRoute: typeof AuthedLotteryBousaiCallbackImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/lottery/bousai/mock': {
      id: '/_authed/lottery/bousai/mock'
      path: '/lottery/bousai/mock'
      fullPath: '/lottery/bousai/mock'
      preLoaderRoute: typeof AuthedLotteryBousaiMockImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/lottery/grant/processing': {
      id: '/_authed/lottery/grant/processing'
      path: '/lottery/grant/processing'
      fullPath: '/lottery/grant/processing'
      preLoaderRoute: typeof AuthedLotteryGrantProcessingImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/lottery/grant/result': {
      id: '/_authed/lottery/grant/result'
      path: '/lottery/grant/result'
      fullPath: '/lottery/grant/result'
      preLoaderRoute: typeof AuthedLotteryGrantResultImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/transfer/accept/$transferCode': {
      id: '/_authed/transfer/accept/$transferCode'
      path: '/transfer/accept/$transferCode'
      fullPath: '/transfer/accept/$transferCode'
      preLoaderRoute: typeof AuthedTransferAcceptTransferCodeImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/charge/credit-card/manage_/$gmoCardId': {
      id: '/_authed/charge/credit-card/manage_/$gmoCardId'
      path: '/charge/credit-card/manage/$gmoCardId'
      fullPath: '/charge/credit-card/manage/$gmoCardId'
      preLoaderRoute: typeof AuthedChargeCreditCardManageGmoCardIdImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/transfer/input/$fundSourceId/$amount': {
      id: '/_authed/transfer/input/$fundSourceId/$amount'
      path: '/transfer/input/$fundSourceId/$amount'
      fullPath: '/transfer/input/$fundSourceId/$amount'
      preLoaderRoute: typeof AuthedTransferInputFundSourceIdAmountImport
      parentRoute: typeof AuthedImport
    }
    '/_authed/transfer/qr/$fundSourceId/$amount': {
      id: '/_authed/transfer/qr/$fundSourceId/$amount'
      path: '/transfer/qr/$fundSourceId/$amount'
      fullPath: '/transfer/qr/$fundSourceId/$amount'
      preLoaderRoute: typeof AuthedTransferQrFundSourceIdAmountImport
      parentRoute: typeof AuthedImport
    }
  }
}

// Create and export the route tree

interface AuthedRouteChildren {
  AuthedAboutAdditionalCampaignRoute: typeof AuthedAboutAdditionalCampaignRoute
  AuthedAboutCampaignRoute: typeof AuthedAboutCampaignRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedChargeCompleteRoute: typeof AuthedChargeCompleteRoute
  AuthedChargeCreditRoute: typeof AuthedChargeCreditRoute
  AuthedChargeMypaymentRoute: typeof AuthedChargeMypaymentRoute
  AuthedDDistributionCodeRoute: typeof AuthedDDistributionCodeRoute
  AuthedHkpCodeRoute: typeof AuthedHkpCodeRoute
  AuthedIInvitationCodeRoute: typeof AuthedIInvitationCodeRoute
  AuthedInvitationApplyRoute: typeof AuthedInvitationApplyRoute
  AuthedInvitationDetailRoute: typeof AuthedInvitationDetailRoute
  AuthedKyotoRepresentativeCampaignProcessingRoute: typeof AuthedKyotoRepresentativeCampaignProcessingRoute
  AuthedLotteryApplyRoute: typeof AuthedLotteryApplyRoute
  AuthedLotteryProcessingRoute: typeof AuthedLotteryProcessingRoute
  AuthedLotteryResultRoute: typeof AuthedLotteryResultRoute
  AuthedPayStoreSlugRoute: typeof AuthedPayStoreSlugRoute
  AuthedResidenceCardApplyRoute: typeof AuthedResidenceCardApplyRoute
  AuthedSdDistributionCodeRoute: typeof AuthedSdDistributionCodeRoute
  AuthedTransactionsGroupIdRoute: typeof AuthedTransactionsGroupIdRoute
  AuthedBalancesIndexRoute: typeof AuthedBalancesIndexRoute
  AuthedChargeIndexRoute: typeof AuthedChargeIndexRoute
  AuthedInvitationIndexRoute: typeof AuthedInvitationIndexRoute
  AuthedKyotoRepresentativeCampaignIndexRoute: typeof AuthedKyotoRepresentativeCampaignIndexRoute
  AuthedReceiveIndexRoute: typeof AuthedReceiveIndexRoute
  AuthedSettingsIndexRoute: typeof AuthedSettingsIndexRoute
  AuthedStoresIndexRoute: typeof AuthedStoresIndexRoute
  AuthedSubscribeIndexRoute: typeof AuthedSubscribeIndexRoute
  AuthedTransactionsIndexRoute: typeof AuthedTransactionsIndexRoute
  AuthedTransferIndexRoute: typeof AuthedTransferIndexRoute
  AuthedChargeCreditCardAddRoute: typeof AuthedChargeCreditCardAddRoute
  AuthedChargeCreditCardManageRoute: typeof AuthedChargeCreditCardManageRoute
  AuthedLotteryBousaiCallbackRoute: typeof AuthedLotteryBousaiCallbackRoute
  AuthedLotteryBousaiMockRoute: typeof AuthedLotteryBousaiMockRoute
  AuthedLotteryGrantProcessingRoute: typeof AuthedLotteryGrantProcessingRoute
  AuthedLotteryGrantResultRoute: typeof AuthedLotteryGrantResultRoute
  AuthedTransferAcceptTransferCodeRoute: typeof AuthedTransferAcceptTransferCodeRoute
  AuthedChargeCreditCardManageGmoCardIdRoute: typeof AuthedChargeCreditCardManageGmoCardIdRoute
  AuthedTransferInputFundSourceIdAmountRoute: typeof AuthedTransferInputFundSourceIdAmountRoute
  AuthedTransferQrFundSourceIdAmountRoute: typeof AuthedTransferQrFundSourceIdAmountRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAboutAdditionalCampaignRoute: AuthedAboutAdditionalCampaignRoute,
  AuthedAboutCampaignRoute: AuthedAboutCampaignRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedChargeCompleteRoute: AuthedChargeCompleteRoute,
  AuthedChargeCreditRoute: AuthedChargeCreditRoute,
  AuthedChargeMypaymentRoute: AuthedChargeMypaymentRoute,
  AuthedDDistributionCodeRoute: AuthedDDistributionCodeRoute,
  AuthedHkpCodeRoute: AuthedHkpCodeRoute,
  AuthedIInvitationCodeRoute: AuthedIInvitationCodeRoute,
  AuthedInvitationApplyRoute: AuthedInvitationApplyRoute,
  AuthedInvitationDetailRoute: AuthedInvitationDetailRoute,
  AuthedKyotoRepresentativeCampaignProcessingRoute:
    AuthedKyotoRepresentativeCampaignProcessingRoute,
  AuthedLotteryApplyRoute: AuthedLotteryApplyRoute,
  AuthedLotteryProcessingRoute: AuthedLotteryProcessingRoute,
  AuthedLotteryResultRoute: AuthedLotteryResultRoute,
  AuthedPayStoreSlugRoute: AuthedPayStoreSlugRoute,
  AuthedResidenceCardApplyRoute: AuthedResidenceCardApplyRoute,
  AuthedSdDistributionCodeRoute: AuthedSdDistributionCodeRoute,
  AuthedTransactionsGroupIdRoute: AuthedTransactionsGroupIdRoute,
  AuthedBalancesIndexRoute: AuthedBalancesIndexRoute,
  AuthedChargeIndexRoute: AuthedChargeIndexRoute,
  AuthedInvitationIndexRoute: AuthedInvitationIndexRoute,
  AuthedKyotoRepresentativeCampaignIndexRoute:
    AuthedKyotoRepresentativeCampaignIndexRoute,
  AuthedReceiveIndexRoute: AuthedReceiveIndexRoute,
  AuthedSettingsIndexRoute: AuthedSettingsIndexRoute,
  AuthedStoresIndexRoute: AuthedStoresIndexRoute,
  AuthedSubscribeIndexRoute: AuthedSubscribeIndexRoute,
  AuthedTransactionsIndexRoute: AuthedTransactionsIndexRoute,
  AuthedTransferIndexRoute: AuthedTransferIndexRoute,
  AuthedChargeCreditCardAddRoute: AuthedChargeCreditCardAddRoute,
  AuthedChargeCreditCardManageRoute: AuthedChargeCreditCardManageRoute,
  AuthedLotteryBousaiCallbackRoute: AuthedLotteryBousaiCallbackRoute,
  AuthedLotteryBousaiMockRoute: AuthedLotteryBousaiMockRoute,
  AuthedLotteryGrantProcessingRoute: AuthedLotteryGrantProcessingRoute,
  AuthedLotteryGrantResultRoute: AuthedLotteryGrantResultRoute,
  AuthedTransferAcceptTransferCodeRoute: AuthedTransferAcceptTransferCodeRoute,
  AuthedChargeCreditCardManageGmoCardIdRoute:
    AuthedChargeCreditCardManageGmoCardIdRoute,
  AuthedTransferInputFundSourceIdAmountRoute:
    AuthedTransferInputFundSourceIdAmountRoute,
  AuthedTransferQrFundSourceIdAmountRoute:
    AuthedTransferQrFundSourceIdAmountRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AuthedRouteWithChildren
  '/about-additional-campaign': typeof AuthedAboutAdditionalCampaignRoute
  '/about-campaign': typeof AuthedAboutCampaignRoute
  '/s/$storeSlug': typeof SStoreSlugRoute
  '/': typeof AuthedIndexRoute
  '/closed': typeof ClosedIndexRoute
  '/charge/complete': typeof AuthedChargeCompleteRoute
  '/charge/credit': typeof AuthedChargeCreditRoute
  '/charge/mypayment': typeof AuthedChargeMypaymentRoute
  '/d/$distributionCode': typeof AuthedDDistributionCodeRoute
  '/hkp/$code': typeof AuthedHkpCodeRoute
  '/i/$invitationCode': typeof AuthedIInvitationCodeRoute
  '/invitation/apply': typeof AuthedInvitationApplyRoute
  '/invitation/detail': typeof AuthedInvitationDetailRoute
  '/kyoto-representative-campaign/processing': typeof AuthedKyotoRepresentativeCampaignProcessingRoute
  '/lottery/apply': typeof AuthedLotteryApplyRoute
  '/lottery/processing': typeof AuthedLotteryProcessingRoute
  '/lottery/result': typeof AuthedLotteryResultRoute
  '/pay/$storeSlug': typeof AuthedPayStoreSlugRoute
  '/residence-card/apply': typeof AuthedResidenceCardApplyRoute
  '/sd/$distributionCode': typeof AuthedSdDistributionCodeRoute
  '/transactions/$groupId': typeof AuthedTransactionsGroupIdRoute
  '/balances': typeof AuthedBalancesIndexRoute
  '/charge': typeof AuthedChargeIndexRoute
  '/invitation': typeof AuthedInvitationIndexRoute
  '/kyoto-representative-campaign': typeof AuthedKyotoRepresentativeCampaignIndexRoute
  '/receive': typeof AuthedReceiveIndexRoute
  '/settings': typeof AuthedSettingsIndexRoute
  '/stores': typeof AuthedStoresIndexRoute
  '/subscribe': typeof AuthedSubscribeIndexRoute
  '/transactions': typeof AuthedTransactionsIndexRoute
  '/transfer': typeof AuthedTransferIndexRoute
  '/charge/credit-card/add': typeof AuthedChargeCreditCardAddRoute
  '/charge/credit-card/manage': typeof AuthedChargeCreditCardManageRoute
  '/lottery/bousai/callback': typeof AuthedLotteryBousaiCallbackRoute
  '/lottery/bousai/mock': typeof AuthedLotteryBousaiMockRoute
  '/lottery/grant/processing': typeof AuthedLotteryGrantProcessingRoute
  '/lottery/grant/result': typeof AuthedLotteryGrantResultRoute
  '/transfer/accept/$transferCode': typeof AuthedTransferAcceptTransferCodeRoute
  '/charge/credit-card/manage/$gmoCardId': typeof AuthedChargeCreditCardManageGmoCardIdRoute
  '/transfer/input/$fundSourceId/$amount': typeof AuthedTransferInputFundSourceIdAmountRoute
  '/transfer/qr/$fundSourceId/$amount': typeof AuthedTransferQrFundSourceIdAmountRoute
}

export interface FileRoutesByTo {
  '/about-additional-campaign': typeof AuthedAboutAdditionalCampaignRoute
  '/about-campaign': typeof AuthedAboutCampaignRoute
  '/s/$storeSlug': typeof SStoreSlugRoute
  '/': typeof AuthedIndexRoute
  '/closed': typeof ClosedIndexRoute
  '/charge/complete': typeof AuthedChargeCompleteRoute
  '/charge/credit': typeof AuthedChargeCreditRoute
  '/charge/mypayment': typeof AuthedChargeMypaymentRoute
  '/d/$distributionCode': typeof AuthedDDistributionCodeRoute
  '/hkp/$code': typeof AuthedHkpCodeRoute
  '/i/$invitationCode': typeof AuthedIInvitationCodeRoute
  '/invitation/apply': typeof AuthedInvitationApplyRoute
  '/invitation/detail': typeof AuthedInvitationDetailRoute
  '/kyoto-representative-campaign/processing': typeof AuthedKyotoRepresentativeCampaignProcessingRoute
  '/lottery/apply': typeof AuthedLotteryApplyRoute
  '/lottery/processing': typeof AuthedLotteryProcessingRoute
  '/lottery/result': typeof AuthedLotteryResultRoute
  '/pay/$storeSlug': typeof AuthedPayStoreSlugRoute
  '/residence-card/apply': typeof AuthedResidenceCardApplyRoute
  '/sd/$distributionCode': typeof AuthedSdDistributionCodeRoute
  '/transactions/$groupId': typeof AuthedTransactionsGroupIdRoute
  '/balances': typeof AuthedBalancesIndexRoute
  '/charge': typeof AuthedChargeIndexRoute
  '/invitation': typeof AuthedInvitationIndexRoute
  '/kyoto-representative-campaign': typeof AuthedKyotoRepresentativeCampaignIndexRoute
  '/receive': typeof AuthedReceiveIndexRoute
  '/settings': typeof AuthedSettingsIndexRoute
  '/stores': typeof AuthedStoresIndexRoute
  '/subscribe': typeof AuthedSubscribeIndexRoute
  '/transactions': typeof AuthedTransactionsIndexRoute
  '/transfer': typeof AuthedTransferIndexRoute
  '/charge/credit-card/add': typeof AuthedChargeCreditCardAddRoute
  '/charge/credit-card/manage': typeof AuthedChargeCreditCardManageRoute
  '/lottery/bousai/callback': typeof AuthedLotteryBousaiCallbackRoute
  '/lottery/bousai/mock': typeof AuthedLotteryBousaiMockRoute
  '/lottery/grant/processing': typeof AuthedLotteryGrantProcessingRoute
  '/lottery/grant/result': typeof AuthedLotteryGrantResultRoute
  '/transfer/accept/$transferCode': typeof AuthedTransferAcceptTransferCodeRoute
  '/charge/credit-card/manage/$gmoCardId': typeof AuthedChargeCreditCardManageGmoCardIdRoute
  '/transfer/input/$fundSourceId/$amount': typeof AuthedTransferInputFundSourceIdAmountRoute
  '/transfer/qr/$fundSourceId/$amount': typeof AuthedTransferQrFundSourceIdAmountRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/_authed/about-additional-campaign': typeof AuthedAboutAdditionalCampaignRoute
  '/_authed/about-campaign': typeof AuthedAboutCampaignRoute
  '/s/$storeSlug': typeof SStoreSlugRoute
  '/_authed/': typeof AuthedIndexRoute
  '/closed/': typeof ClosedIndexRoute
  '/_authed/charge/complete': typeof AuthedChargeCompleteRoute
  '/_authed/charge/credit': typeof AuthedChargeCreditRoute
  '/_authed/charge/mypayment': typeof AuthedChargeMypaymentRoute
  '/_authed/d/$distributionCode': typeof AuthedDDistributionCodeRoute
  '/_authed/hkp/$code': typeof AuthedHkpCodeRoute
  '/_authed/i/$invitationCode': typeof AuthedIInvitationCodeRoute
  '/_authed/invitation/apply': typeof AuthedInvitationApplyRoute
  '/_authed/invitation/detail': typeof AuthedInvitationDetailRoute
  '/_authed/kyoto-representative-campaign/processing': typeof AuthedKyotoRepresentativeCampaignProcessingRoute
  '/_authed/lottery/apply': typeof AuthedLotteryApplyRoute
  '/_authed/lottery/processing': typeof AuthedLotteryProcessingRoute
  '/_authed/lottery/result': typeof AuthedLotteryResultRoute
  '/_authed/pay/$storeSlug': typeof AuthedPayStoreSlugRoute
  '/_authed/residence-card/apply': typeof AuthedResidenceCardApplyRoute
  '/_authed/sd/$distributionCode': typeof AuthedSdDistributionCodeRoute
  '/_authed/transactions/$groupId': typeof AuthedTransactionsGroupIdRoute
  '/_authed/balances/': typeof AuthedBalancesIndexRoute
  '/_authed/charge/': typeof AuthedChargeIndexRoute
  '/_authed/invitation/': typeof AuthedInvitationIndexRoute
  '/_authed/kyoto-representative-campaign/': typeof AuthedKyotoRepresentativeCampaignIndexRoute
  '/_authed/receive/': typeof AuthedReceiveIndexRoute
  '/_authed/settings/': typeof AuthedSettingsIndexRoute
  '/_authed/stores/': typeof AuthedStoresIndexRoute
  '/_authed/subscribe/': typeof AuthedSubscribeIndexRoute
  '/_authed/transactions/': typeof AuthedTransactionsIndexRoute
  '/_authed/transfer/': typeof AuthedTransferIndexRoute
  '/_authed/charge/credit-card/add': typeof AuthedChargeCreditCardAddRoute
  '/_authed/charge/credit-card/manage': typeof AuthedChargeCreditCardManageRoute
  '/_authed/lottery/bousai/callback': typeof AuthedLotteryBousaiCallbackRoute
  '/_authed/lottery/bousai/mock': typeof AuthedLotteryBousaiMockRoute
  '/_authed/lottery/grant/processing': typeof AuthedLotteryGrantProcessingRoute
  '/_authed/lottery/grant/result': typeof AuthedLotteryGrantResultRoute
  '/_authed/transfer/accept/$transferCode': typeof AuthedTransferAcceptTransferCodeRoute
  '/_authed/charge/credit-card/manage_/$gmoCardId': typeof AuthedChargeCreditCardManageGmoCardIdRoute
  '/_authed/transfer/input/$fundSourceId/$amount': typeof AuthedTransferInputFundSourceIdAmountRoute
  '/_authed/transfer/qr/$fundSourceId/$amount': typeof AuthedTransferQrFundSourceIdAmountRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/about-additional-campaign'
    | '/about-campaign'
    | '/s/$storeSlug'
    | '/'
    | '/closed'
    | '/charge/complete'
    | '/charge/credit'
    | '/charge/mypayment'
    | '/d/$distributionCode'
    | '/hkp/$code'
    | '/i/$invitationCode'
    | '/invitation/apply'
    | '/invitation/detail'
    | '/kyoto-representative-campaign/processing'
    | '/lottery/apply'
    | '/lottery/processing'
    | '/lottery/result'
    | '/pay/$storeSlug'
    | '/residence-card/apply'
    | '/sd/$distributionCode'
    | '/transactions/$groupId'
    | '/balances'
    | '/charge'
    | '/invitation'
    | '/kyoto-representative-campaign'
    | '/receive'
    | '/settings'
    | '/stores'
    | '/subscribe'
    | '/transactions'
    | '/transfer'
    | '/charge/credit-card/add'
    | '/charge/credit-card/manage'
    | '/lottery/bousai/callback'
    | '/lottery/bousai/mock'
    | '/lottery/grant/processing'
    | '/lottery/grant/result'
    | '/transfer/accept/$transferCode'
    | '/charge/credit-card/manage/$gmoCardId'
    | '/transfer/input/$fundSourceId/$amount'
    | '/transfer/qr/$fundSourceId/$amount'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/about-additional-campaign'
    | '/about-campaign'
    | '/s/$storeSlug'
    | '/'
    | '/closed'
    | '/charge/complete'
    | '/charge/credit'
    | '/charge/mypayment'
    | '/d/$distributionCode'
    | '/hkp/$code'
    | '/i/$invitationCode'
    | '/invitation/apply'
    | '/invitation/detail'
    | '/kyoto-representative-campaign/processing'
    | '/lottery/apply'
    | '/lottery/processing'
    | '/lottery/result'
    | '/pay/$storeSlug'
    | '/residence-card/apply'
    | '/sd/$distributionCode'
    | '/transactions/$groupId'
    | '/balances'
    | '/charge'
    | '/invitation'
    | '/kyoto-representative-campaign'
    | '/receive'
    | '/settings'
    | '/stores'
    | '/subscribe'
    | '/transactions'
    | '/transfer'
    | '/charge/credit-card/add'
    | '/charge/credit-card/manage'
    | '/lottery/bousai/callback'
    | '/lottery/bousai/mock'
    | '/lottery/grant/processing'
    | '/lottery/grant/result'
    | '/transfer/accept/$transferCode'
    | '/charge/credit-card/manage/$gmoCardId'
    | '/transfer/input/$fundSourceId/$amount'
    | '/transfer/qr/$fundSourceId/$amount'
  id:
    | '__root__'
    | '/_authed'
    | '/_authed/about-additional-campaign'
    | '/_authed/about-campaign'
    | '/s/$storeSlug'
    | '/_authed/'
    | '/closed/'
    | '/_authed/charge/complete'
    | '/_authed/charge/credit'
    | '/_authed/charge/mypayment'
    | '/_authed/d/$distributionCode'
    | '/_authed/hkp/$code'
    | '/_authed/i/$invitationCode'
    | '/_authed/invitation/apply'
    | '/_authed/invitation/detail'
    | '/_authed/kyoto-representative-campaign/processing'
    | '/_authed/lottery/apply'
    | '/_authed/lottery/processing'
    | '/_authed/lottery/result'
    | '/_authed/pay/$storeSlug'
    | '/_authed/residence-card/apply'
    | '/_authed/sd/$distributionCode'
    | '/_authed/transactions/$groupId'
    | '/_authed/balances/'
    | '/_authed/charge/'
    | '/_authed/invitation/'
    | '/_authed/kyoto-representative-campaign/'
    | '/_authed/receive/'
    | '/_authed/settings/'
    | '/_authed/stores/'
    | '/_authed/subscribe/'
    | '/_authed/transactions/'
    | '/_authed/transfer/'
    | '/_authed/charge/credit-card/add'
    | '/_authed/charge/credit-card/manage'
    | '/_authed/lottery/bousai/callback'
    | '/_authed/lottery/bousai/mock'
    | '/_authed/lottery/grant/processing'
    | '/_authed/lottery/grant/result'
    | '/_authed/transfer/accept/$transferCode'
    | '/_authed/charge/credit-card/manage_/$gmoCardId'
    | '/_authed/transfer/input/$fundSourceId/$amount'
    | '/_authed/transfer/qr/$fundSourceId/$amount'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  SStoreSlugRoute: typeof SStoreSlugRoute
  ClosedIndexRoute: typeof ClosedIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  SStoreSlugRoute: SStoreSlugRoute,
  ClosedIndexRoute: ClosedIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authed",
        "/s/$storeSlug",
        "/closed/"
      ]
    },
    "/_authed": {
      "filePath": "_authed.tsx",
      "children": [
        "/_authed/about-additional-campaign",
        "/_authed/about-campaign",
        "/_authed/",
        "/_authed/charge/complete",
        "/_authed/charge/credit",
        "/_authed/charge/mypayment",
        "/_authed/d/$distributionCode",
        "/_authed/hkp/$code",
        "/_authed/i/$invitationCode",
        "/_authed/invitation/apply",
        "/_authed/invitation/detail",
        "/_authed/kyoto-representative-campaign/processing",
        "/_authed/lottery/apply",
        "/_authed/lottery/processing",
        "/_authed/lottery/result",
        "/_authed/pay/$storeSlug",
        "/_authed/residence-card/apply",
        "/_authed/sd/$distributionCode",
        "/_authed/transactions/$groupId",
        "/_authed/balances/",
        "/_authed/charge/",
        "/_authed/invitation/",
        "/_authed/kyoto-representative-campaign/",
        "/_authed/receive/",
        "/_authed/settings/",
        "/_authed/stores/",
        "/_authed/subscribe/",
        "/_authed/transactions/",
        "/_authed/transfer/",
        "/_authed/charge/credit-card/add",
        "/_authed/charge/credit-card/manage",
        "/_authed/lottery/bousai/callback",
        "/_authed/lottery/bousai/mock",
        "/_authed/lottery/grant/processing",
        "/_authed/lottery/grant/result",
        "/_authed/transfer/accept/$transferCode",
        "/_authed/charge/credit-card/manage_/$gmoCardId",
        "/_authed/transfer/input/$fundSourceId/$amount",
        "/_authed/transfer/qr/$fundSourceId/$amount"
      ]
    },
    "/_authed/about-additional-campaign": {
      "filePath": "_authed/about-additional-campaign.tsx",
      "parent": "/_authed"
    },
    "/_authed/about-campaign": {
      "filePath": "_authed/about-campaign.tsx",
      "parent": "/_authed"
    },
    "/s/$storeSlug": {
      "filePath": "s/$storeSlug.tsx"
    },
    "/_authed/": {
      "filePath": "_authed/index.tsx",
      "parent": "/_authed"
    },
    "/closed/": {
      "filePath": "closed/index.tsx"
    },
    "/_authed/charge/complete": {
      "filePath": "_authed/charge/complete.tsx",
      "parent": "/_authed"
    },
    "/_authed/charge/credit": {
      "filePath": "_authed/charge/credit.tsx",
      "parent": "/_authed"
    },
    "/_authed/charge/mypayment": {
      "filePath": "_authed/charge/mypayment.tsx",
      "parent": "/_authed"
    },
    "/_authed/d/$distributionCode": {
      "filePath": "_authed/d/$distributionCode.tsx",
      "parent": "/_authed"
    },
    "/_authed/hkp/$code": {
      "filePath": "_authed/hkp/$code.tsx",
      "parent": "/_authed"
    },
    "/_authed/i/$invitationCode": {
      "filePath": "_authed/i/$invitationCode.tsx",
      "parent": "/_authed"
    },
    "/_authed/invitation/apply": {
      "filePath": "_authed/invitation/apply.tsx",
      "parent": "/_authed"
    },
    "/_authed/invitation/detail": {
      "filePath": "_authed/invitation/detail.tsx",
      "parent": "/_authed"
    },
    "/_authed/kyoto-representative-campaign/processing": {
      "filePath": "_authed/kyoto-representative-campaign/processing.tsx",
      "parent": "/_authed"
    },
    "/_authed/lottery/apply": {
      "filePath": "_authed/lottery/apply.tsx",
      "parent": "/_authed"
    },
    "/_authed/lottery/processing": {
      "filePath": "_authed/lottery/processing.tsx",
      "parent": "/_authed"
    },
    "/_authed/lottery/result": {
      "filePath": "_authed/lottery/result.tsx",
      "parent": "/_authed"
    },
    "/_authed/pay/$storeSlug": {
      "filePath": "_authed/pay/$storeSlug.tsx",
      "parent": "/_authed"
    },
    "/_authed/residence-card/apply": {
      "filePath": "_authed/residence-card/apply.tsx",
      "parent": "/_authed"
    },
    "/_authed/sd/$distributionCode": {
      "filePath": "_authed/sd/$distributionCode.tsx",
      "parent": "/_authed"
    },
    "/_authed/transactions/$groupId": {
      "filePath": "_authed/transactions/$groupId.tsx",
      "parent": "/_authed"
    },
    "/_authed/balances/": {
      "filePath": "_authed/balances/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/charge/": {
      "filePath": "_authed/charge/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/invitation/": {
      "filePath": "_authed/invitation/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/kyoto-representative-campaign/": {
      "filePath": "_authed/kyoto-representative-campaign/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/receive/": {
      "filePath": "_authed/receive/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/settings/": {
      "filePath": "_authed/settings/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/stores/": {
      "filePath": "_authed/stores/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/subscribe/": {
      "filePath": "_authed/subscribe/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/transactions/": {
      "filePath": "_authed/transactions/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/transfer/": {
      "filePath": "_authed/transfer/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/charge/credit-card/add": {
      "filePath": "_authed/charge/credit-card.add.tsx",
      "parent": "/_authed"
    },
    "/_authed/charge/credit-card/manage": {
      "filePath": "_authed/charge/credit-card.manage.tsx",
      "parent": "/_authed"
    },
    "/_authed/lottery/bousai/callback": {
      "filePath": "_authed/lottery/bousai.callback.tsx",
      "parent": "/_authed"
    },
    "/_authed/lottery/bousai/mock": {
      "filePath": "_authed/lottery/bousai.mock.tsx",
      "parent": "/_authed"
    },
    "/_authed/lottery/grant/processing": {
      "filePath": "_authed/lottery/grant.processing.tsx",
      "parent": "/_authed"
    },
    "/_authed/lottery/grant/result": {
      "filePath": "_authed/lottery/grant.result.tsx",
      "parent": "/_authed"
    },
    "/_authed/transfer/accept/$transferCode": {
      "filePath": "_authed/transfer/accept.$transferCode.tsx",
      "parent": "/_authed"
    },
    "/_authed/charge/credit-card/manage_/$gmoCardId": {
      "filePath": "_authed/charge/credit-card.manage_.$gmoCardId.tsx",
      "parent": "/_authed"
    },
    "/_authed/transfer/input/$fundSourceId/$amount": {
      "filePath": "_authed/transfer/input.$fundSourceId.$amount.tsx",
      "parent": "/_authed"
    },
    "/_authed/transfer/qr/$fundSourceId/$amount": {
      "filePath": "_authed/transfer/qr.$fundSourceId.$amount.tsx",
      "parent": "/_authed"
    }
  }
}
ROUTE_MANIFEST_END */
